import React from "react";
import { Badge } from "@chakra-ui/react";

const STATUS_SCHEMES = {
  DRAFT: "blue",
  PUBLISHED: "green",
  ACTIVE: "green",
  COMPLETED: "green",
  ACKNOWLEDGED: "green",
  FINALIZED: "green",
  IN_PROGRESS: "blue",
  SUBMITTED: "blue",
  UPLOADED: "blue",
  PARSING: "blue",
  NEEDS_MAPPING: "orange",
  VALID: "green",
  IMPORTED: "green",
  INACTIVE: "orange",
  PENDING: "orange",
  ARCHIVED: "gray",
  SKIPPED: "gray",
  FAILED: "red",
  INVALID: "red",
  REJECTED: "red",
  SENT_BACK: "orange",
};

const humanize = (value) =>
  String(value || "Unknown")
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

const StatusBadge = ({ value, children, ...props }) => {
  const normalized = String(value || children || "UNKNOWN").toUpperCase();
  return (
    <Badge colorScheme={STATUS_SCHEMES[normalized] || "gray"} {...props}>
      {children || humanize(value)}
    </Badge>
  );
};

export default StatusBadge;
